import { withNamespaces } from "react-i18next";
import React, { memo, useMemo } from "react";
import { Col, Container, Row } from "reactstrap";
import { useLocation } from "react-router-dom";
// styles
import "./style.scss";
// components
import Tabs from "./tabs";

// Contents
import DataProtectionSoftwareList from "src/modules/data-protection/pages/admin/software/list";
import { withRouter } from "react-router-dom";
import PageBody from "../../../components/page-body";
import PageContent from "../../../components/page-content";
import Navigator from "src/components/Navigator";
import DataProtectionSoftwareService from "../../../apis/DataProtectionSoftwareService";
import { useQuery } from "@tanstack/react-query";

const DataProtectionSoftwareMainPage = (props) => {
    const location = useLocation();

    const navigatorOptions = useMemo(() => {
        return {
            enable: true,
            pageTitle: "Software Assets",
            breadCrumbs: [
                {
                    title: "SIP",
                    link: "/admin/data-protection/dashboard",
                },
                {
                    title: "Software Assets",
                    link: "#",
                }
            ]
        }
    }, []);

    const {
        data: softwaresCount
    } = useQuery({
        queryKey: ["gdpr-fetch-softwares-count"],
        queryFn: async () => {
            const service = DataProtectionSoftwareService.getInstance();
            return await service.getCount();
        }
    });

    const currentTab = (new URLSearchParams(location.search)).get('tab');
    const renderTabContent = () => {
        return currentTab ? <DataProtectionSoftwareList tab={currentTab} /> : null;
    };

    return (
        <PageContent classNames="data-protection-software-details-page software-details-page">
            <Container fluid>
                <Row>
                    {navigatorOptions.enable && (
                        <Col lg="12" className="mb-4">
                            <Navigator
                                pageTitle={navigatorOptions.pageTitle}
                                breadCrumbs={navigatorOptions.breadCrumbs}
                            />
                        </Col>
                    )}
                </Row>

                <PageBody classNames="p-0">
                    <div className="details-content-wrapper">
                        <Tabs 
                            totalCount={softwaresCount?.data?.all || 0} 
                            deletedCount={softwaresCount?.data?.deleted || 0} 
                        />
                        {renderTabContent()}
                    </div>
                </PageBody>
            </Container>
        </PageContent>
    );
};

export default withNamespaces()(
    withRouter(memo(DataProtectionSoftwareMainPage))
);
